import React from "react";

import styles from "./style.module.css";

import { Button } from "aible";

import { ALERT_TYPES } from "containers/Monitoring/reducer";

import { FAIRNESS_OBJECTIVE } from "containers/Project/reducer";

export default class DataDriftAlertCard extends React.PureComponent {
  getLabel(titleOverride) {
    const { data } = this.props;

    const count = data?.data?.length ?? 0;

    let retTitle = `${count} ${data?.type} Issue${count !== 1 ? "s" : ""} Detected`;

    return retTitle;
  }

  render() {
    const label = this.getLabel();
    return (
      <div className={styles.alertCardWrapper}>
        <AlertCardHeader alertLabel={label} {...this.props} />
        <AlertCardBody alertLabel={label} {...this.props} />
      </div>
    );
  }
}

class AlertCardHeader extends React.PureComponent {
  getHeader() {
    const { alertLabel } = this.props;
    let retHeader = alertLabel;
    return retHeader;
  }

  render() {
    return <div className={styles.alertCardHeader}>{this.getHeader()}</div>;
  }
}

class AlertCardBody extends React.PureComponent {
  getContent() {
    const { data } = this.props;

    const pluralSuffix = data?.data?.length === 1 ? "" : "s";

    let retAlert = "Monitoring results changed more than " + data?.threshold + "% for the following ";
    if (data.type === ALERT_TYPES.DATA_DRIFT) {
      retAlert += "variable value" + pluralSuffix;
    } else if (data.type === ALERT_TYPES.MODEL_DRIFT) {
      retAlert += "metric" + pluralSuffix;
    }

    return (
      <div className={styles.dataDriftAlertWrapper}>
        <div className={styles.dataDriftAlertText}>{retAlert}</div>
        <div className={styles.dataDriftAlertList}>
          <ul>
            {data?.data?.map((d) => {
              return (
                <li key={d?.label}>
                  <strong>{d?.label}</strong>
                  <span style={{ marginLeft: "8px" }}>{"changed by " + d?.change + "%"}</span>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    );

    return retAlert;
  }
  render() {
    const { adjustAssumptions, hideAdjust } = this.props;
    return (
      <div className={styles.alertCardBody}>
        <div className={styles.alertCardContent}>{this.getContent()}</div>
        {!hideAdjust && (
          <div className={styles.alertCardFooter}>
            <Button onClick={() => adjustAssumptions()} style={{ width: "100%" }}>
              {"Adjust Assumptions"}
            </Button>
          </div>
        )}
      </div>
    );
  }
}
